import styled from "styled-components";
import Paper from "@mui/material/Paper";

export const StyledPaper = styled(Paper)`
  & > div {
    padding: 10px;
  }
  & > div > span:first-child {
    color: gray;
  }
  & > div > span:last-child {
    color: black;
    font-size: 16pxّ;
  }
`;
